<app-header></app-header>

<form [formGroup]="form" class="form-div" (ngSubmit)="onEnviar($event)">
  <app-list></app-list>
  <span class='underline'><h3>Iniciar Sesion</h3></span>
    <div class="mb-3">
      <label for="exampleInputEmail1">Email</label>
      <input type="email" formControlName="email"
      [ngClass]="{'is-invalid': Email?.errors && Email?.touched, 'is-valid': !Email?.errors && Email?.touched}"
      class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Ingresa tu email">
      <div *ngIf="Email?.errors && Email?.touched">
        <p *ngIf="Email?.hasError('required')" class="text-danger">
            EMAIL OBLIGATORIO
        </p>
        <p *ngIf="Email?.hasError('email')" class="text-danger">
            FORMATO INVALIDO
        </p>
        </div>
    </div>
    <div class="mb-3">
      <label for="exampleInputPassword1">Contraseña</label>
      <input type="password" formControlName="password"
      [ngClass]="{'is-invalid': Password?.errors && Password?.touched, 'is-valid': !Password?.errors && Password?.touched}"
      class="form-control" id="exampleInputPassword1" placeholder="Ingresa tu contraseña">

      <div *ngIf="Password?.errors && Password?.touched">
        <p *ngIf="Password?.hasError('required')" class="text-danger">
        CONTRASEÑA OBLIGATORIA
        </p>
      </div>
    </div>
    <button type="submit" class="btn btn-primary" >Enviar</button>
  </form>
  <div class="footer">
    
  <app-footer></app-footer>
  </div>